import axios from "@/plugins/axios";

let url = "/api/v1/partner/nanuri";

export const nanuri = {
    auth: {
        getAccessToken(data){
            return axios.post(`${url}/token`, data).then(result => {
                let { token } = result.data;
                return {
                    accessToken: token,
                    ...result.data
                }
            });
        },
    },
    order: {
        post(data){
            return axios.post(`${url}/charge`, data).then(result => result.data);
        }
    },
    cash: {
        get(data){
            return axios.get(`${url}/own`, data).then(result => result.data);
        }
    },
    usage: {
        get(data){
            return axios.get(`${url}/usage`, data).then(result => result.data);
        }
    }
}